"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartBarTwoTone = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ChartBarTwoTone = function ChartBarTwoTone() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("rect", {
    width: "6",
    height: "16.5",
    fill: "currentColor",
    rx: "1",
    transform: "matrix(-1 0 0 1 22.5 6)"
  }), react_1.default.createElement("rect", {
    width: "6",
    height: "21",
    fill: "currentColor",
    opacity: "0.72",
    rx: "1",
    transform: "matrix(-1 0 0 1 15 1.5)"
  }), react_1.default.createElement("rect", {
    width: "6",
    height: "12",
    fill: "currentColor",
    rx: "1",
    transform: "matrix(-1 0 0 1 7.5 10.5)"
  }));
};

exports.ChartBarTwoTone = ChartBarTwoTone;